/**
 * 葬儀注文フォームのバリデーション
 */

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("funeral-order-form");
    if (!form) return;

    // バリデーションルール（1基目）
    const validationRules = {
      "deceased-name": {
        required: true,
        message: "故人名を入力してください",
      },
      "chief-mourner": {
        required: false,
        message: "喪主名を入力してください",
      },
      "wake-date": {
        // 通夜は任意項目
        required: false,
        message: "通夜の日付を選択してください",
        linkedField: "wake-time",
        validatePair: true, // 片方だけ入力されている場合のチェック用
      },
      "wake-time": {
        // 通夜は任意項目
        required: false,
        message: "通夜の時刻を選択してください",
        linkedField: "wake-date",
        validatePair: true, // 片方だけ入力されている場合のチェック用
      },
      "funeral-date": {
        required: true,
        message: "告別式の日付を選択してください",
        linkedField: "funeral-time",
      },
      "funeral-time": {
        required: true,
        message: "告別式の時刻を選択してください",
        linkedField: "funeral-date",
      },
      "orderer-name": {
        required: true,
        message: "発注者様のお名前を入力してください",
      },
      "orderer-phone": {
        required: true,
        pattern: /^[0-9０-９\-\ー\－\s\(\)（）]+$/,
        minLength: 10,
        message:
          "電話番号を正しく入力してください（例：090-1234-5678、03-1234-5678）",
      },
      "nameplate-name": {
        required: true,
        message: "お札に表記するお名前を入力してください",
      },
      "nameplate-furigana": {
        required: true,
        pattern: /^[\u30A0-\u30FF\s]+$/,
        message: "フリガナをカタカナで入力してください",
      },
      "nameplate-title1": {
        // 文字数制限なし
        message: "名称1を入力してください",
      },
      "nameplate-title2": {
        // 文字数制限なし
        message: "名称2を入力してください",
      },
      "nameplate-titles-furigana": {
        pattern: /^[\u30A0-\u30FF\s]*$/,
        message: "名称のフリガナはカタカナで入力してください",
      },

      // 2基目のバリデーションルール（すべて任意）
      "deceased-name-2": {
        required: false,
        message: "故人名を入力してください",
      },
      "chief-mourner-2": {
        required: false,
        message: "喪主名を入力してください",
      },
      "wake-date-2": {
        required: false,
        message: "通夜の日付を選択してください",
        linkedField: "wake-time-2",
        validatePair: true,
      },
      "wake-time-2": {
        required: false,
        message: "通夜の時刻を選択してください",
        linkedField: "wake-date-2",
        validatePair: true,
      },
      "funeral-date-2": {
        required: false,
        message: "告別式の日付を選択してください",
        linkedField: "funeral-time-2",
        validatePair: true,
      },
      "funeral-time-2": {
        required: false,
        message: "告別式の時刻を選択してください",
        linkedField: "funeral-date-2",
        validatePair: true,
      },
      "orderer-name-2": {
        required: false,
        message: "発注者様のお名前を入力してください",
      },
      "orderer-phone-2": {
        required: false,
        pattern: /^[0-9０-９\-\ー\－\s\(\)（）]+$/,
        minLength: 10,
        message:
          "電話番号を正しく入力してください（例：090-1234-5678、03-1234-5678）",
      },
      "nameplate-name-2": {
        required: false,
        message: "お札に表記するお名前を入力してください",
      },
      "nameplate-furigana-2": {
        required: false,
        pattern: /^[\u30A0-\u30FF\s]+$/,
        message: "フリガナをカタカナで入力してください",
      },
      "nameplate-title1-2": {
        required: false,
        message: "名称1を入力してください",
      },
      "nameplate-title2-2": {
        required: false,
        message: "名称2を入力してください",
      },
      "nameplate-titles-furigana-2": {
        required: false,
        pattern: /^[\u30A0-\u30FF\s]*$/,
        message: "名称のフリガナはカタカナで入力してください",
      },
      "privacy-consent": {
        required: true,
        message: "個人情報の取り扱いに同意してください",
      },
    };

    // エラーメッセージを表示
    function showError(fieldId, message) {
      const field = document.getElementById(fieldId);
      let errorElement = document.getElementById(fieldId + "-error");

      // 日付・時刻フィールドの場合、共通のエラー要素を使用
      if (fieldId === "funeral-date" || fieldId === "funeral-time") {
        errorElement = document.getElementById("funeral-datetime-error");
      } else if (fieldId === "wake-date" || fieldId === "wake-time") {
        errorElement = document.getElementById("wake-datetime-error");
      } else if (fieldId === "funeral-date-2" || fieldId === "funeral-time-2") {
        errorElement = document.getElementById("funeral-datetime-2-error");
      } else if (fieldId === "wake-date-2" || fieldId === "wake-time-2") {
        errorElement = document.getElementById("wake-datetime-2-error");
      }

      if (field && errorElement) {
        // エラークラスを追加（赤い枠とアニメーション）
        field.classList.add("error");

        // 連動フィールドもエラー表示
        const rules = validationRules[fieldId];
        if (rules && rules.linkedField) {
          const linkedField = document.getElementById(rules.linkedField);
          if (linkedField) {
            linkedField.classList.add("error");
          }
        }

        // エラーメッセージを表示
        errorElement.textContent = message;
        errorElement.style.display = "block";
        errorElement.classList.add("show");

        // フィールドを振動させる（再アニメーション）
        field.style.animation = "none";
        setTimeout(() => {
          field.style.animation = "";
        }, 10);

        // フィールドにフォーカスを当てる
        if (document.activeElement !== field) {
          // field.focus();
        }
      }
    }

    // エラーメッセージをクリア
    function clearError(fieldId) {
      const field = document.getElementById(fieldId);
      let errorElement = document.getElementById(fieldId + "-error");

      // 日付・時刻フィールドの場合、共通のエラー要素を使用
      if (fieldId === "funeral-date" || fieldId === "funeral-time") {
        errorElement = document.getElementById("funeral-datetime-error");
      } else if (fieldId === "wake-date" || fieldId === "wake-time") {
        errorElement = document.getElementById("wake-datetime-error");
      } else if (fieldId === "funeral-date-2" || fieldId === "funeral-time-2") {
        errorElement = document.getElementById("funeral-datetime-2-error");
      } else if (fieldId === "wake-date-2" || fieldId === "wake-time-2") {
        errorElement = document.getElementById("wake-datetime-2-error");
      }

      if (field) {
        field.classList.remove("error");

        // 連動フィールドもクリア
        const rules = validationRules[fieldId];
        if (rules && rules.linkedField) {
          const linkedField = document.getElementById(rules.linkedField);
          if (linkedField) {
            linkedField.classList.remove("error");
          }
        }
      }

      if (errorElement) {
        errorElement.textContent = "";
        errorElement.style.display = "none";
        errorElement.classList.remove("show");
      }
    }

  // 受付期限のチェック
  function validateDeliveryDeadline(dateFieldId, timeFieldId, type) {
    const dateField = document.getElementById(dateFieldId);
    const timeField = document.getElementById(timeFieldId);
    
    if (!dateField || !timeField || !dateField.value || !timeField.value) {
      return true;
    }

    const selectedDate = new Date(dateField.value);
    const [hours, minutes] = timeField.value.split(':').map(Number);
    selectedDate.setHours(hours, minutes, 0, 0);

    const now = new Date();

    // 通夜入力の有無を確認（1基目/2基目両対応）
    const wakeDateValue = document.getElementById(dateFieldId.includes('-2') ? 'wake-date-2' : 'wake-date')?.value;
    const wakeTimeValue = document.getElementById(dateFieldId.includes('-2') ? 'wake-time-2' : 'wake-time')?.value;
    const hasWake = !!(wakeDateValue && wakeTimeValue);

    if (type === 'wake') {
      // 通夜当日の12:00まで受付
      const deadline = new Date(selectedDate);
      deadline.setHours(12, 0, 0, 0);
      if (now >= deadline) {
        const msg = '通夜当日の12:00以降はご注文を受け付けできません。';
        showError(dateFieldId, msg);
        return false;
      }
    } else if (type === 'funeral') {
      if (hasWake) {
        // 通夜がある場合 → 通夜側ルールで制御済み
        return true;
      } else {
        // 通夜がない場合 → 告別式前日の12:00以降はエラー
        const deadline = new Date(selectedDate);
        deadline.setDate(deadline.getDate() - 1);
        deadline.setHours(12, 0, 0, 0);
        if (now >= deadline) {
          const msg = '告別式前日の12:00以降はご注文を受け付けできません。';
          showError(dateFieldId, msg);
          return false;
        }
      }
    }
    return true;
  }

    // フィールドのバリデーション
    function validateField(fieldId) {
      const field = document.getElementById(fieldId);
      if (!field) return true;

      const rules = validationRules[fieldId];
      if (!rules) return true;

      const value =
        field.type === "checkbox" ? field.checked : field.value.trim();

      // 必須チェック
      if (rules.required && !value) {
        showError(fieldId, rules.message);
        return false;
      }

      // ペアバリデーション（通夜の日付と時刻）
      if (rules.validatePair && rules.linkedField) {
        const linkedField = document.getElementById(rules.linkedField);
        if (linkedField) {
          const linkedValue = linkedField.value.trim();
          // 片方だけ入力されている場合はエラー
          if ((value && !linkedValue) || (!value && linkedValue)) {
            let errorMessage;
            if (fieldId.includes("wake")) {
              errorMessage = "通夜を入力する場合は日付と時刻の両方を入力してください";
            } else if (fieldId.includes("funeral")) {
              errorMessage = "告別式を入力する場合は日付と時刻の両方を入力してください";
            } else {
              errorMessage = "日付と時刻の両方を入力してください";
            }
            showError(fieldId, errorMessage);
            return false;
          }
        }
      }

      // 受付期限チェック（通夜）
      if ((fieldId === "wake-date" || fieldId === "wake-time") && value) {
        const dateField = document.getElementById("wake-date");
        const timeField = document.getElementById("wake-time");
        if (dateField && dateField.value && timeField && timeField.value) {
          if (!validateDeliveryDeadline("wake-date", "wake-time", "wake")) {
            return false;
          }
        }
      }

      // 受付期限チェック（告別式）
      if ((fieldId === "funeral-date" || fieldId === "funeral-time") && value) {
        const dateField = document.getElementById("funeral-date");
        const timeField = document.getElementById("funeral-time");
        if (dateField && dateField.value && timeField && timeField.value) {
          if (
            !validateDeliveryDeadline("funeral-date", "funeral-time", "funeral")
          ) {
            return false;
          }
        }
      }

      // 受付期限チェック（通夜 - 2基目）
      if ((fieldId === "wake-date-2" || fieldId === "wake-time-2") && value) {
        const dateField = document.getElementById("wake-date-2");
        const timeField = document.getElementById("wake-time-2");
        if (dateField && dateField.value && timeField && timeField.value) {
          if (!validateDeliveryDeadline("wake-date-2", "wake-time-2", "wake")) {
            return false;
          }
        }
      }

      // 受付期限チェック（告別式 - 2基目）
      if (
        (fieldId === "funeral-date-2" || fieldId === "funeral-time-2") &&
        value
      ) {
        const dateField = document.getElementById("funeral-date-2");
        const timeField = document.getElementById("funeral-time-2");
        if (dateField && dateField.value && timeField && timeField.value) {
          if (
            !validateDeliveryDeadline(
              "funeral-date-2",
              "funeral-time-2",
              "funeral"
            )
          ) {
            return false;
          }
        }
      }

      // パターンチェック
      if (rules.pattern && value && !rules.pattern.test(value)) {
        showError(fieldId, rules.message);
        return false;
      }

      // 最小文字数チェック
      if (
        rules.minLength &&
        value &&
        value.replace(/[\s\-\ー\－\(\)（）]/g, "").length < rules.minLength
      ) {
        showError(fieldId, rules.message);
        return false;
      }

      // 最大文字数チェック（削除済み - 文字数制限なし）
      // if (rules.maxLength && value.length > rules.maxLength) {
      //   showError(fieldId, rules.message);
      //   return false;
      // }

      clearError(fieldId);
      return true;
    }

    // 全フィールドのバリデーション
    function validateAllFields() {
      let isValid = true;
      let firstErrorField = null;

      // 通常のフィールドバリデーション
      for (const fieldId in validationRules) {
        if (!validateField(fieldId)) {
          isValid = false;
          if (!firstErrorField) {
            firstErrorField = document.getElementById(fieldId);
          }
        }
      }

      // 受付期限の追加チェック（通夜）
      const wakeDateField = document.getElementById("wake-date");
      const wakeTimeField = document.getElementById("wake-time");
      if (
        wakeDateField &&
        wakeDateField.value &&
        wakeTimeField &&
        wakeTimeField.value
      ) {
        if (!validateDeliveryDeadline("wake-date", "wake-time", "wake")) {
          isValid = false;
          if (!firstErrorField) {
            firstErrorField = wakeDateField;
          }
        }
      }

      // 受付期限の追加チェック（告別式）
      const funeralDateField = document.getElementById("funeral-date");
      const funeralTimeField = document.getElementById("funeral-time");
      if (
        funeralDateField &&
        funeralDateField.value &&
        funeralTimeField &&
        funeralTimeField.value
      ) {
        if (
          !validateDeliveryDeadline("funeral-date", "funeral-time", "funeral")
        ) {
          isValid = false;
          if (!firstErrorField) {
            firstErrorField = funeralDateField;
          }
        }
      }

      // 受付期限の追加チェック（通夜 - 2基目）
      const wakeDateField2 = document.getElementById("wake-date-2");
      const wakeTimeField2 = document.getElementById("wake-time-2");
      if (
        wakeDateField2 &&
        wakeDateField2.value &&
        wakeTimeField2 &&
        wakeTimeField2.value
      ) {
        if (!validateDeliveryDeadline("wake-date-2", "wake-time-2", "wake")) {
          isValid = false;
          if (!firstErrorField) {
            firstErrorField = wakeDateField2;
          }
        }
      }

      // 受付期限の追加チェック（告別式 - 2基目）
      const funeralDateField2 = document.getElementById("funeral-date-2");
      const funeralTimeField2 = document.getElementById("funeral-time-2");
      if (
        funeralDateField2 &&
        funeralDateField2.value &&
        funeralTimeField2 &&
        funeralTimeField2.value
      ) {
        if (
          !validateDeliveryDeadline("funeral-date-2", "funeral-time-2", "funeral")
        ) {
          isValid = false;
          if (!firstErrorField) {
            firstErrorField = funeralDateField2;
          }
        }
      }

      // 通夜・告別式の関係チェック（1基目）
      const wakeDateValue = document.getElementById('wake-date')?.value;
      const funeralDateValue = document.getElementById('funeral-date')?.value;
      if (wakeDateValue && funeralDateValue) {
        const wakeDate = new Date(wakeDateValue);
        const funeralDate = new Date(funeralDateValue);
        const expectedFuneral = new Date(wakeDate);
        expectedFuneral.setDate(wakeDate.getDate() + 1);

        // 同年同月同日の比較
        if (
          funeralDate.getFullYear() !== expectedFuneral.getFullYear() ||
          funeralDate.getMonth() !== expectedFuneral.getMonth() ||
          funeralDate.getDate() !== expectedFuneral.getDate()
        ) {
          showError('funeral-date', '告別式は通夜の翌日に設定してください');
          isValid = false;
        }
      }

      // 通夜・告別式の関係チェック（2基目）
      const wakeDateValue2 = document.getElementById('wake-date-2')?.value;
      const funeralDateValue2 = document.getElementById('funeral-date-2')?.value;
      if (wakeDateValue2 && funeralDateValue2) {
        const wakeDate2 = new Date(wakeDateValue2);
        const funeralDate2 = new Date(funeralDateValue2);
        const expectedFuneral2 = new Date(wakeDate2);
        expectedFuneral2.setDate(wakeDate2.getDate() + 1);

        if (
          funeralDate2.getFullYear() !== expectedFuneral2.getFullYear() ||
          funeralDate2.getMonth() !== expectedFuneral2.getMonth() ||
          funeralDate2.getDate() !== expectedFuneral2.getDate()
        ) {
          showError('funeral-date-2', '告別式は通夜の翌日に設定してください');
          isValid = false;
        }
      }

      // 最初のエラーフィールドにスクロールしてフォーカス
      if (firstErrorField) {
        setTimeout(() => {
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          firstErrorField.focus();
        }, 100);
      }

      return isValid;
    }

    // 各フィールドにイベントリスナーを追加
    for (const fieldId in validationRules) {
      const field = document.getElementById(fieldId);
      if (field) {
        // フォーカスアウト時にバリデーション
        field.addEventListener("blur", function () {
          validateField(fieldId);
        });

        // 入力時にエラーをクリア
        field.addEventListener("input", function () {
          if (field.classList.contains("error")) {
            validateField(fieldId);
          }
        });

        // 日付・時刻フィールドの場合、changeイベントでもバリデーション
        if (fieldId.includes("date") || fieldId.includes("time")) {
          field.addEventListener("change", function () {
            validateField(fieldId);
            // 連動フィールドもバリデーション
            const rules = validationRules[fieldId];
            if (rules && rules.linkedField) {
              validateField(rules.linkedField);
            }
          });
        }

        if (field.type === "checkbox") {
          field.addEventListener("change", function () {
            validateField(fieldId);
          });
        }
      }
    }

    // チェックアウトボタンのクリックイベントをインターセプト
    const checkoutButton = document.getElementById("checkout");
    if (checkoutButton) {
      checkoutButton.addEventListener("click", function (e) {
        // カートが空の場合は処理を停止
        if (checkoutButton.disabled) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        // カートが空でない場合のみバリデーション
        if (!validateAllFields()) {
          e.preventDefault();
          e.stopPropagation();

          // エラーメッセージを表示
          const firstErrorField = document.querySelector(
            ".funeral-order-form__input.error"
          );
          if (firstErrorField) {
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField.focus();
          }

          alert("必須項目を正しく入力してください。");
          return false;
        }
      });
    }

    // フォーム送信時のバリデーション
    const cartForm = document.getElementById("cart");
    if (cartForm) {
      cartForm.addEventListener("submit", function (e) {
        if (!validateAllFields()) {
          e.preventDefault();
          return false;
        }
      });
    }

    // 電話番号フィールドの自動フォーマット（1基目・2基目両対応）
    const phoneFields = ["orderer-phone", "orderer-phone-2"];
    phoneFields.forEach(function(phoneFieldId) {
      const phoneField = document.getElementById(phoneFieldId);
      if (phoneField) {
        phoneField.addEventListener("input", function (e) {
          let value = e.target.value;

          // 全角数字を半角に変換
          value = value.replace(/[０-９]/g, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
          });

          // 全角ハイフンを半角に変換
          value = value.replace(/[ー－]/g, "-");

          // 括弧を統一
          value = value.replace(/[（]/g, "(");
          value = value.replace(/[）]/g, ")");

          // 数字とハイフンと括弧とスペース以外を削除
          value = value.replace(/[^\d\-\(\)\s]/g, "");

          e.target.value = value;
        });

        // フォーカスアウト時に簡単な整形
        phoneField.addEventListener("blur", function (e) {
          let value = e.target.value.trim();

          // 数字のみの場合、自動でハイフンを入れる
          const digitsOnly = value.replace(/[^\d]/g, "");

          if (digitsOnly.length === 10) {
            // 固定電話（03-1234-5678）の形式
            if (digitsOnly.startsWith("0")) {
              const areaCode = digitsOnly.slice(0, 2);
              if (["03", "06"].includes(areaCode)) {
                value =
                  digitsOnly.slice(0, 2) +
                  "-" +
                  digitsOnly.slice(2, 6) +
                  "-" +
                  digitsOnly.slice(6);
              } else {
                value =
                  digitsOnly.slice(0, 3) +
                  "-" +
                  digitsOnly.slice(3, 6) +
                  "-" +
                  digitsOnly.slice(6);
              }
            }
          } else if (digitsOnly.length === 11) {
            // 携帯電話（090-1234-5678）の形式
            if (digitsOnly.startsWith("0")) {
              value =
                digitsOnly.slice(0, 3) +
                "-" +
                digitsOnly.slice(3, 7) +
                "-" +
                digitsOnly.slice(7);
            }
          }

          e.target.value = value;
        });
      }
    });

    // カタカナフィールドの入力補助メッセージ表示（1基目・2基目両対応）
    // 自動変換は行わず、バリデーションのみで対応
    const katakanaFields = ["nameplate-furigana", "nameplate-titles-furigana", "nameplate-furigana-2", "nameplate-titles-furigana-2"];
    katakanaFields.forEach(function (fieldId) {
      const field = document.getElementById(fieldId);
      if (field) {
        // フォーカス時にカタカナ入力を促すメッセージを表示（オプション）
        field.addEventListener("focus", function () {
          const hintElement = field.parentElement.querySelector(
            ".funeral-order-form__hint"
          );
          if (hintElement && !hintElement.classList.contains("highlight")) {
            hintElement.classList.add("highlight");
          }
        });

        field.addEventListener("blur", function () {
          const hintElement = field.parentElement.querySelector(
            ".funeral-order-form__hint"
          );
          if (hintElement && hintElement.classList.contains("highlight")) {
            hintElement.classList.remove("highlight");
          }
        });
      }
    });

    // 日付フィールドに今日の日付をデフォルトで設定（オプション）
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    // 通夜のデフォルト日付（今日）
    const wakeDateField = document.getElementById("wake-date");
    if (wakeDateField && !wakeDateField.value) {
      wakeDateField.min = formatDate(today);
    }

    // 告別式のデフォルト日付（明日）
    const funeralDateField = document.getElementById("funeral-date");
    if (funeralDateField && !funeralDateField.value) {
      funeralDateField.min = formatDate(tomorrow);
    }

    // 2基目の日付フィールドにも最小値設定
    const wakeDateField2 = document.getElementById("wake-date-2");
    if (wakeDateField2 && !wakeDateField2.value) {
      wakeDateField2.min = formatDate(today);
    }

    const funeralDateField2 = document.getElementById("funeral-date-2");
    if (funeralDateField2 && !funeralDateField2.value) {
      funeralDateField2.min = formatDate(tomorrow);
    }

    // カート数量を取得する関数（複数の方法で取得）
    function getCartItemCount() {
      // 方法1: カートアイコンのバブルから取得
      const cartCountBubble = document.querySelector(
        '.cart-count-bubble span[aria-hidden="true"]'
      );
      if (cartCountBubble && cartCountBubble.textContent) {
        const count = parseInt(cartCountBubble.textContent);
        if (!isNaN(count)) {
          return count;
        }
      }

      // 方法2: カートアイテムの数を直接カウント
      const cartItems = document.querySelectorAll('.cart-item, [data-line-item]');
      if (cartItems.length > 0) {
        let totalQuantity = 0;
        cartItems.forEach(item => {
          const quantityInput = item.querySelector('input[name*="quantity"]');
          if (quantityInput) {
            totalQuantity += parseInt(quantityInput.value) || 0;
          }
        });
        if (totalQuantity > 0) {
          return totalQuantity;
        }
      }

      // 方法3: グローバル変数から取得（Shopifyテーマで利用可能な場合）
      if (typeof window.cart !== 'undefined' && window.cart.item_count) {
        return window.cart.item_count;
      }

      // 方法4: その他のカートカウント要素から取得
      const otherCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart-items-count');
      for (const element of otherCountElements) {
        const count = parseInt(element.textContent || element.dataset.cartCount);
        if (!isNaN(count)) {
          return count;
        }
      }

      return 0;
    }

    // カート更新時にボタンの状態を更新
    function updateCheckoutButtonState() {
      const checkoutButton = document.getElementById("checkout");
      if (!checkoutButton) return;

      const cartItemCount = getCartItemCount();

      // カートが空の場合はボタンを無効化
      if (cartItemCount === 0) {
        checkoutButton.disabled = true;
        checkoutButton.setAttribute("disabled", "disabled");
      } else {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute("disabled");
      }
    }

    // 2基目フォームの表示・非表示を制御
    function toggleSecondFormDisplay() {
      const secondForm = document.getElementById("funeral-order-form-2");
      if (!secondForm) return;

      const cartItemCount = getCartItemCount();

      // 現在の表示状態を確認
      const isCurrentlyVisible = secondForm.style.display !== "none" && 
                                 !secondForm.classList.contains('hiding');

      // 2点以上の場合は表示、1点以下の場合は非表示
      if (cartItemCount > 1) {
        if (!isCurrentlyVisible) {
          secondForm.style.display = "block";
          secondForm.classList.remove('hiding');
          secondForm.classList.add('show', 'animate-in');
          
          // アニメーション後にクラスを削除
          setTimeout(() => {
            secondForm.classList.remove('animate-in');
          }, 400);
          
          // 2基目フォームが表示された時にイベントリスナーを再追加
          addEventListenersToSecondForm();
        }
      } else {
        if (isCurrentlyVisible) {
          secondForm.classList.add('hiding');
          secondForm.classList.remove('show');
          
          // フェードアウト後に非表示にする
          setTimeout(() => {
            secondForm.style.display = "none";
            secondForm.classList.remove('hiding');
            // 2基目フォームが非表示になった時にエラーをクリア
            clearSecondFormErrors();
          }, 300);
        }
      }
    }

    // 2基目フォームのエラーをクリア
    function clearSecondFormErrors() {
      const secondFormFields = [
        "deceased-name-2", "chief-mourner-2", "wake-date-2", "wake-time-2",
        "funeral-date-2", "funeral-time-2", "orderer-name-2", "orderer-phone-2",
        "nameplate-name-2", "nameplate-furigana-2", "nameplate-title1-2",
        "nameplate-title2-2", "nameplate-titles-furigana-2"
      ];

      secondFormFields.forEach(fieldId => {
        clearError(fieldId);
        const field = document.getElementById(fieldId);
        if (field) {
          field.classList.remove("error");
          if (field.type === "checkbox") {
            field.checked = false;
          } else {
            field.value = "";
          }
        }
      });
    }

    // 2基目フォームにイベントリスナーを追加
    function addEventListenersToSecondForm() {
      const secondFormFields = [
        "deceased-name-2", "chief-mourner-2", "wake-date-2", "wake-time-2",
        "funeral-date-2", "funeral-time-2", "orderer-name-2", "orderer-phone-2",
        "nameplate-name-2", "nameplate-furigana-2", "nameplate-title1-2",
        "nameplate-title2-2", "nameplate-titles-furigana-2"
      ];

      secondFormFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field && validationRules[fieldId]) {
          // 既存のイベントリスナーがない場合のみ追加
          if (!field.hasAttribute('data-listeners-added')) {
            // フォーカスアウト時にバリデーション
            field.addEventListener("blur", function () {
              validateField(fieldId);
            });

            // 入力時にエラーをクリア
            field.addEventListener("input", function () {
              if (field.classList.contains("error")) {
                validateField(fieldId);
              }
            });

            // 日付・時刻フィールドの場合、changeイベントでもバリデーション
            if (fieldId.includes("date") || fieldId.includes("time")) {
              field.addEventListener("change", function () {
                validateField(fieldId);
                // 連動フィールドもバリデーション
                const rules = validationRules[fieldId];
                if (rules && rules.linkedField) {
                  validateField(rules.linkedField);
                }
              });
            }

            if (field.type === "checkbox") {
              field.addEventListener("change", function () {
                validateField(fieldId);
              });
            }

            field.setAttribute('data-listeners-added', 'true');
          }
        }
      });
    }

    // カート更新イベントを監視（PubSubイベントも監視）
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        updateCheckoutButtonState();
        toggleSecondFormDisplay();
      });
    }

    // カート更新イベントを監視（従来のイベントも維持）
    document.addEventListener("cart:updated", function () {
      updateCheckoutButtonState();
      toggleSecondFormDisplay();
    });

    // ページ読み込み時の初期化処理
    function initializeForm() {
      updateCheckoutButtonState();
      toggleSecondFormDisplay();
    }

    // 遅延初期化（DOM要素が確実に読み込まれてから実行）
    function delayedInitialization() {
      setTimeout(() => {
        initializeForm();
      }, 500);
    }

    // 【1基目からコピー】ボタンの処理（セクションごと）
    (function setupCopyButtons() {
      function copyFields(pairs) {
        pairs.forEach(function (pair) {
          var src = document.getElementById(pair[0]);
          var dst = document.getElementById(pair[1]);
          if (src && dst) {
            dst.value = src.value;
            dst.dispatchEvent(new Event('input', { bubbles: true }));
            dst.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      var btnFuneral = document.getElementById('copy-funeral-info-btn');
      if (btnFuneral) {
        btnFuneral.addEventListener('click', function () {
          copyFields([
            ['deceased-name',  'deceased-name-2'],
            ['chief-mourner',  'chief-mourner-2'],
            ['wake-date',      'wake-date-2'],
            ['wake-time',      'wake-time-2'],
            ['funeral-date',   'funeral-date-2'],
            ['funeral-time',   'funeral-time-2']
          ]);
        });
      }

      var btnOrderer = document.getElementById('copy-orderer-info-btn');
      if (btnOrderer) {
        btnOrderer.addEventListener('click', function () {
          copyFields([
            ['orderer-name',  'orderer-name-2'],
            ['orderer-phone', 'orderer-phone-2']
          ]);
        });
      }

      var btnNameplate = document.getElementById('copy-nameplate-info-btn');
      if (btnNameplate) {
        btnNameplate.addEventListener('click', function () {
          copyFields([
            ['nameplate-name',           'nameplate-name-2'],
            ['nameplate-furigana',       'nameplate-furigana-2'],
            ['nameplate-title1',         'nameplate-title1-2'],
            ['nameplate-title2',         'nameplate-title2-2'],
            ['nameplate-titles-furigana','nameplate-titles-furigana-2']
          ]);
        });
      }
    })();

    // 即座に初期化を実行
    initializeForm();

    // 少し遅れて再度初期化（DOM構築完了後）
    delayedInitialization();

    // さらに遅れて初期化（すべてのリソース読み込み後）
    setTimeout(() => {
      initializeForm();
    }, 1500);

    // 定期的にボタンの状態と2基目フォームの表示をチェック（フォールバック）
    setInterval(() => {
      updateCheckoutButtonState();
      toggleSecondFormDisplay();
    }, 2000);

    // ページ全体の読み込み完了時にも初期化を実行
    window.addEventListener('load', function() {
      setTimeout(() => {
        const form = document.getElementById("funeral-order-form");
        if (form) {
          // カート数量を取得して2基目フォームの表示を制御
          const cartItemCount = getCartItemCount();
          const secondForm = document.getElementById("funeral-order-form-2");
          
          if (secondForm && cartItemCount > 1) {
            secondForm.style.display = "block";
            secondForm.classList.add('show');
            
            // 2基目フォームのイベントリスナーを追加
            addEventListenersToSecondForm();
          }
        }
      }, 200);
    });
  });

  window.getCartItemCount = getCartItemCount;
})();
